export const uiCopy = {
  en: {
    map: {
      showHistory: 'Historical moves',
      showHistoryHelp: 'Show previous addresses and moves. When off, only current addresses are shown.',
      drawArea: 'Select area',
      drawAreaHelp: 'Drag a rectangle on the map. Only companies with an active address in the area are selected. Press Esc to cancel.',
      selectViewport: 'Select visible map area',
      clearArea: 'Clear area selection',
      areaResult: '{{count}} companies in the selected area.',
      areaScope: 'Selection applies to companies in the loaded network and filters both graph and map.',
    },
    chartExport: {
      savePng: 'Save as PNG',
      exportChart: 'Save {{title}} as {{format}}',
      exportFailed: 'The image could not be saved. Try again or choose SVG.',
    },
    personSearchDescription: 'Find a person’s company roles and explore their engagement history and connected companies.',
    personSearchStart: 'Search for board positions',
    personSearchHelp: 'Enter a 12-digit personal number above to explore company roles and history.',
    shortestPathDescription: 'Choose two companies to explore how they are connected.',
    rulesDescription: 'Manage the rules used to assess companies.',
    rulesEmpty: 'No rule sets yet',
    rulesEmptyHelp: 'Create a rule set to define how companies are assessed.',
  },
  sv: {
    map: {
      showHistory: 'Historiska flyttar',
      showHistoryHelp: 'Visa tidigare adresser och flyttar. Avstängt visas bara aktuella adresser.',
      drawArea: 'Markera område',
      drawAreaHelp: 'Dra en rektangel på kartan. Endast bolag med en aktiv adress i området väljs. Avbryt med Esc.',
      selectViewport: 'Välj synligt kartområde',
      clearArea: 'Rensa områdesurval',
      areaResult: '{{count}} bolag i områdesurvalet.',
      areaScope: 'Urvalet gäller bolag i det inlästa nätverket och filtrerar både grafen och kartan.',
    },
    chartExport: {
      savePng: 'Spara som PNG',
      exportChart: 'Spara {{title}} som {{format}}',
      exportFailed: 'Bilden kunde inte sparas. Försök igen eller välj SVG.',
    },
    personSearchDescription: 'Hitta en persons företagsroller och utforska engagemangshistorik och kopplade företag.',
    personSearchStart: 'Sök efter styrelseuppdrag',
    personSearchHelp: 'Ange ett 12-siffrigt personnummer ovan för att utforska företagsroller och historik.',
    shortestPathDescription: 'Välj två företag för att utforska hur de är kopplade till varandra.',
    rulesDescription: 'Hantera reglerna som används för att bedöma företag.',
    rulesEmpty: 'Inga regeluppsättningar ännu',
    rulesEmptyHelp: 'Skapa en regeluppsättning för att definiera hur företag bedöms.',
  },
};
